import { Stack } from '@mui/material'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { TruckVisitsViewStore } from '../../Stores/TruckVisitsViewStore'

interface Props {
  store: TruckVisitsViewStore
}

export const TruckTimeRange = observer(({ store }: Props) => {
  const { t } = useTranslate()

  const [startTime, setStartTime] = useState(store.timeRangeStart)
  const [endTime, setEndTime] = useState(store.timeRangeEnd)
  const [error, setError] = useState(false)

  const onApply = () => {
    if (!startTime && !endTime) {
      store.clearTimeRange()
    } else {
      const from = startTime ?? dayjs().startOf('date').toDate()
      const to = endTime ?? dayjs().startOf('date').add(1, 'd').toDate()
      store.setTimeRange(from, to)
    }

    store.toggleTimeRangeDialog(false)
  }

  const onClear = () => {
    setStartTime(undefined)
    setEndTime(undefined)
    store.clearTimeRange()
    store.toggleTimeRangeDialog(false)
  }

  return (
    <ConfirmationDialog
      open={store.isTimeRangeDialogOpen}
      maxWidth='sm'
      primaryActionDisabled={error}
      title={t('selectTimeRange', 'Select time range')}
      primaryActionText={t('apply', 'Apply')}
      closeLabel={t('clear', 'Clear')}
      onClose={onClear}
      onConfirm={onApply}
      hasBorderTop
    >
      <Stack id='time-range-form' flexDirection='row' gap={2} mb={2} mt={1}>
        <TimePicker
          ampm={false}
          value={startTime ? dayjs(startTime) : null}
          label={t('from', 'From')}
          onError={error => setError(error != null)}
          onChange={data => {
            setStartTime(data?.toDate())
          }}
        />

        <TimePicker
          ampm={false}
          value={endTime ? dayjs(endTime) : null}
          label={t('to', 'To')}
          onError={error => setError(error != null)}
          onChange={data => {
            setEndTime(data?.toDate())
          }}
        />
      </Stack>
    </ConfirmationDialog>
  )
})
